<template>
  <div class="d-flex-column justify-start align-start gap-24 mt-20">
    <GamePackBanner />

    <!-- <div class="d-flex-row align-start space-between xl-row-to-col gap-24">
      <div
        class="d-flex-column flex-8 justify-start align-start t-white gap-24"
        style="max-height: max-content"
      >
        <SeasonLength
          v-if="showSeasonLength"
          :season-length="getGame?.game_season"
        />
      </div>

      <div class="d-flex-column flex-2 justify-start align-start t-white">
        <SafeSecurePayments :hide="true" />
      </div>
    </div> -->

    <div
      class="d-flex-row align-start space-between xl-row-to-col gap-24 mobile-min-height"
    >
      <div class="d-flex-row flex-15 t-white" style="min-height: 48px">
        <div class="d-flex-column justify-start align-start gap-16">
          <LazyCustomSeasonLengthNew
            v-if="showSeasonLength"
            :season-length="getGame?.game_season"
          />
          <PackSelector />
        </div>
      </div>
      <!-- PACKS HERE -->
      <div
        class="d-flex-column flex-65 justify-start align-start t-white gap-24"
      >
        <MmrBoost v-if="currentGamePackSlug === 'dota-2-mmr-boost-service'" />
        <DotaWinRate
          v-else-if="currentGamePackSlug === 'dota-2-win-rate-boosting'"
        />
        <DotaCallibration
          v-else-if="currentGamePackSlug === 'dota-2-calibration-boost'"
        />
        <DotaLowPriority
          v-else-if="currentGamePackSlug === 'dota-2-low-priority-removal'"
        />
        <DotaUnrated
          v-else-if="currentGamePackSlug === 'dota-2-unrated-matches-boosting'"
        />
        <!-- LARGE FAQS -->

        <div class="d-flex-column justify-start xl-hide" v-if="getPackFaq">
          <p
            class="t-orange regular-l f-w-500 font-family-1"
            style="letter-spacing: 2px"
          >
            {{ $t("homepage.faq") }}s
          </p>
          <Faq :faqs="getPackFaq" variant="pack" />
        </div>
      </div>
      <!-- CART HERE -->
      <div
        class="d-flex-column flex-2 justify-start align-start t-white cart_container"
      >
        <WhyWeCheap />
        <Cart />
        <SafeSecurePayments />

        <div
          class="d-flex-column justify-start above-xl-hide"
          v-if="getPackFaq"
          style="margin-top: 24px"
        >
          <p
            class="t-orange regular-l f-w-500 font-family-1"
            style="letter-spacing: 2px"
          >
            {{ $t("homepage.faq") }}s
          </p>
          <Faq :faqs="getPackFaq" variant="pack" />
        </div>
      </div>
    </div>
    <PackOptimalText />
  </div>
</template>

<script setup>
import GamePackBanner from "~/components/banners/GamePackBanner.vue";
import PackSelector from "~/components/common/sections/boosting/PackSelector.vue";
import Faq from "~/components/custom/Faq.vue";
import PackOptimalText from "~/components/common/PackOptimalText.vue";
import Cart from "~/components/calculators/checkout/Cart.vue";
import SafeSecurePayments from "~/components/calculators/checkout/SafeSecurePayments.vue";
import MmrBoost from "~/components/calculators/dota2/MmrBoost.vue";
import DotaWinRate from "~/components/calculators/dota2/DotaWinRate.vue";
import DotaCallibration from "~/components/calculators/dota2/DotaCallibration.vue";
import DotaLowPriority from "~/components/calculators/dota2/DotaLowPriority.vue";
import DotaUnrated from "~/components/calculators/dota2/DotaUnrated.vue";
import { computed } from "vue";
import WhyWeCheap from "~/components/custom/WhyWeCheap.vue";
import SeasonLength from "~/components/custom/SeasonLength.vue";

const { getGamePack, getGame } = useGameStore();
const { currentGamePackSlug } = useGameComposable();

const getPackFaq = computed(() => {
  if (getGamePack?.faqs) {
    return getGamePack?.faqs;
  }

  return null;
});
const showSeasonLength = computed(() => {
  if (!getGame?.id) return false;
  if (getGame?.game_season?.id) return true;
  return false;
});
</script>
